module.exports = __webpack_public_path__ + "fonts/nucleo-icons.woff!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.woff
// module id = 110
// module chunks = 0